import {
  styled,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@material-ui/core';
import { FilledButton, BackgroundPaper } from '@ds/react-components';

export const PageContainer = styled('div')({});

export const TermsTitle = styled('h1')(({ theme }) => ({
  color: theme.palette.common.darkgray,
  fontSize: '26px',
  fontWeight: 'bold',
}));

export const NonModalPaper = styled(BackgroundPaper)({
  width: '100%',
  marginTop: '24px',
});

export const NonModalHeaderContainer = styled('div')({
  padding: '15px',
  borderBottom: '1px solid rgba(0, 0, 0, 0.08)',
});

export const NonModalBodyContainer = styled('div')({
  padding: '15px',
});

export const TermsModalTitle = styled('h2')(({ theme }) => ({
  color: theme.palette.common.black,
  fontSize: '20px',
  fontWeight: 'bold',
}));

export const NonModalCheckboxContainer = styled('div')({
  marginTop: '12px',
  display: 'flex',
});

export const ModalHeaderContainer = styled(DialogTitle)({
  padding: '15px',
  borderBottom: '1px solid rgba(0, 0, 0, 0.08)',
  margin: 0,
});

export const ModalBodyContainer = styled(DialogContent)({
  padding: '15px',
});

export const ModalActionsContainer = styled(DialogActions)({
  padding: '15px',
  justifyContent: 'flex-start',
  borderTop: '1px solid rgba(0, 0, 0, 0.08)',
});

export const ModalActionsWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  width: '100%',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  [theme.breakpoints.up('sm')]: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
}));

export const ActionButtonsContainer = styled('div')(({ theme }) => ({
  marginTop: '15px',
  alignSelf: 'flex-end',
  [theme.breakpoints.up('sm')]: {
    marginTop: 0,
    alignSelf: 'auto',
  },
}));

export const AcceptButton = styled(FilledButton)({
  marginLeft: '4px',
});
